import { extendTheme } from "@chakra-ui/react";

// Brand yellow is a light colour: white text on it fails WCAG contrast
// (~1.8:1). Dark ink on yellow reads at ~11:1, so yellow is used as an
// accent and behind dark text only — never as a background for white text.
const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      50: "#FEF9E7",
      100: "#FCEFBC",
      200: "#F8E28C",
      300: "#F4D45C",
      400: "#F0C93A",
      500: "#ECC018", // primary brand yellow
      600: "#C9A20F",
      700: "#96790B",
      800: "#645107",
      900: "#322803",
    },
    ink: {
      50: "#F7F8F9",
      100: "#EDEFF2",
      200: "#DCE0E6",
      300: "#B8C0CC",
      400: "#8A94A6",
      500: "#5C6678",
      600: "#3D4657",
      700: "#2A3140",
      800: "#1A202C", // primary text / dark surfaces
      900: "#11151E",
    },
  },
  fonts: {
    heading: "'League Spartan', system-ui, sans-serif",
    body: "'League Spartan', system-ui, sans-serif",
  },
  styles: {
    global: {
      "html, body": {
        color: "ink.800",
        bg: "white",
        scrollBehavior: "smooth",
      },
      // Offset anchor targets so the sticky header doesn't cover headings.
      "section[id]": {
        scrollMarginTop: "72px",
      },
      "*:focus-visible": {
        outline: "3px solid",
        outlineColor: "brand.600",
        outlineOffset: "2px",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 600,
        borderRadius: "md",
      },
      variants: {
        brand: {
          bg: "brand.500",
          color: "ink.900",
          _hover: { bg: "brand.400", _disabled: { bg: "brand.500" } },
          _active: { bg: "brand.600" },
        },
        outlineInk: {
          border: "1px solid",
          borderColor: "ink.200",
          color: "ink.800",
          bg: "white",
          _hover: { bg: "ink.50" },
        },
      },
    },
    Heading: {
      baseStyle: {
        letterSpacing: "-0.02em",
        fontWeight: 700,
      },
    },
  },
});

export default theme;
